import { createContext, useReducer, useContext } from "react";
import Snackbar from "../ui/Snackbar";

const UtilsContext = createContext(null);

export function useUtils() {
  return useContext(UtilsContext);
}

const initState = {
  alert: {
    open: false,
    content: "",
    autoHideDuration: 4000,
    severity: "success",
    position: { vertical: "bottom", horizontal: "left" },
  },
  // loading: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "set_alert":
      return { ...state, alert: { ...state.alert, ...action.payload } };
    // case "loading":
    //   return { ...state, loading: action.loading };
    default:
      throw new Error(`Invalid dispatch type: ${action.type}`);
  }
};

export default function UtilsProvider({ children }) {
  let [state, dispatch] = useReducer(reducer, initState);

  const handleClose = () => {
    dispatch({ type: "set_alert", payload: { open: false, content: '' } });
  };

  const notify = (content) => {
    setTimeout(handleClose, state.alert.autoHideDuration);
    dispatch({ type: "set_alert", payload: { open: true, content } });
  };

  const alertUser = (content) => {
    setTimeout(handleClose, state.alert.autoHideDuration);
    dispatch({
      type: "set_alert",
      payload: {
        open: true,
        content,
        severity: "error",
        autoHideDuration: 10000,
      },
    });
  };

  let value = { state, notify, alertUser };

  return (
    <UtilsContext.Provider value={value}>
      <Snackbar
        open={state.alert.open}
        // autoHideDuration={state.alert.autoHideDuration}
        onClose={handleClose}
        anchorOrigin={state.alert.position}
        severity={state.alert.severity}
      >
        {/* <Alert
          onClose={handleClose}
          severity={state.alert.severity}
          sx={{ width: "100%" }}
        >
          {state.alert.content}
        </Alert> */}
        {state.alert.content}
      </Snackbar>

      {children}
    </UtilsContext.Provider>
  );
}
